import React, { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../loginSlice";
import "../fonts/breuer-headline.css";
import "./login.css";
import { setBackButtonUrl } from "../uiSlice";
import Swal from "sweetalert2";

function Login() {
  const dispatch = useDispatch();
  const { status, user, error } = useSelector((state) => state.auth);
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );



  
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isAdmin = searchParams.get("admin") === "true";

  useEffect(() => {
    dispatch(loginUser());
  }, [dispatch]);

  useEffect(() => {
    if (status === "succeeded" && user && isAdmin) {
      navigate("/admin");
    }
  }, [status, user, isAdmin, navigate]);

  useEffect(() => {
    if (status === "succeeded" && user?.backButtonRedirect) {
      dispatch(setBackButtonUrl(user.backButtonRedirect));
    }
  }, [status, user, dispatch]);

  useEffect(() => {
    const body = document.body;
    const keys = [
      "background-attachment",
      "background-size",
      "background-repeat",
      "background-position",
      "overflow-x",
      "margin",
      "padding",
      "height",
      "font-family",
      "backdrop-filter",
    ];
    const snapshot = keys.map((k) => [k, body.style.getPropertyValue(k)]);

    body.style.setProperty("background-attachment", "fixed");
    body.style.setProperty("background-size", "100% 100%");
    body.style.setProperty("background-repeat", "no-repeat");
    body.style.setProperty("background-position", "center");
    body.style.setProperty("overflow-x", "hidden");
    body.style.setProperty("margin", "0");
    body.style.setProperty("padding", "0");
    body.style.setProperty("height", "100vh");
    body.style.setProperty(
      "font-family",
      "'FiraSans-Medium', sans-serif",
      "important"
    );
    body.style.setProperty("backdrop-filter", "blur(9px)");

    return () => {
      snapshot.forEach(([k, v]) => {
        if (v) body.style.setProperty(k, v);
        else body.style.removeProperty(k);
      });
    };
  }, []);

 useEffect(() => {
  if (status !== "failed") return;
  const msg = error ? String(error) : "Session expired";
  const redirect = user && user.backButtonRedirect ? user.backButtonRedirect : "/";
  Swal.fire("Session Expired!", msg, "error").then(() => {
    window.location.href = redirect;
  });
}, [status, error, user]);

// show "already played" when login payload has gameover > 0 (DB stages.gameover)
useEffect(() => {
  if (isAdmin) return;
  if (status !== "succeeded" || !user) return;
  if (Number(user.gameover ?? 0) > 0) {
    const msg = error ? String(error) : "You have already played!";
    const redirect = user.backButtonRedirect || "/";
    Swal.fire("You have already played!", "  ", "error").then(() => {
      window.location.href = redirect;
    });
  }
}, [status, user, error, isAdmin]);

  if (status === "loading" || themeStatus === "loading") {
    return (
      <div className="login-main-container">
        <div className="quiz-loader-container">
          <div className="quiz-loader"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-main-container">
      {themeData && (
        <img
          src={process.env.REACT_APP_S3_PATH + themeData.logo}
          className="login-logo1"
          alt="Game Logo"
        />
      )}
        {user && status === "succeeded" && (
        <div
        style={{
          ...(themeData?.button_color ? { background: themeData.button_color } : {}),
          ...(themeData?.button_Textcolor
            ? {
                color: themeData.button_Textcolor,
                borderColor: themeData.button_Textcolor,
              }
            : {}),
          borderRadius: "6px", // ✅ correct camelCase + string value
        }}
      >
            <Link
              to="/welcome"
              className="begin-play-btn"
              style={(() => {
                const raw =
                  themeData?.button_Textcolor ?? themeData?.button_text_color;
                if (raw == null || raw === "") return undefined;
                const c = String(raw).trim();
                return c ? { color: c } : undefined;
              })()}
            >
              BEGIN PLAY
            </Link>
          </div>
        )}
    </div>
  );
}

export default Login;
